const routes = [
    {
        path: "/instructor/exam/requests",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "instructorexamrequest_getinstructorexamrequest"
        }
    }
];

export default routes;
